import { FoodPhotosContext } from "../context/FoodPhotosContext";
import { useContext } from "react";

export const useFoodPhotosContext = () => {
    const context = useContext(FoodPhotosContext);

    if (!context) {
        return Error('useFoodPhotosContext must be used inside an FoodPhotosContextProvider');
    };

    return context;
};